import PropTypes from 'prop-types';
import React from 'react';
import { Box } from '@stitch-fix/mode-react';
import ErrorBoundary from '../shared/ErrorBoundary/ErrorBoundary';
import SizeGuideProvider from './SizeGuideContext/SizeGuideProvider';
import SizeGuide from './SizeGuide';
import './styles.module.scss';

/**
 * The Mobile SizeGuide Page.
 */

const MobileSizeGuidePage = ({ businessLine }: { businessLine: string }) => {
  return (
    <ErrorBoundary>
      <SizeGuideProvider businessLine={businessLine}>
        <Box data-testid="size-guide-container">
          <Box p={1}>
            <SizeGuide />
          </Box>
        </Box>
      </SizeGuideProvider>
    </ErrorBoundary>
  );
};

MobileSizeGuidePage.propTypes = {
  businessLine: PropTypes.string.isRequired,
};

export default MobileSizeGuidePage;
